export class ErrorMessageParameter {
  public description: string;
}
